import Vue from 'vue'
import { XcIcon } from '@/components/index' // svg组件

// register globally
Vue.component('xc-icon', XcIcon)

const req = require.context('./svg', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)